
import { AutoRunSnapshot } from './auto-run-report-snapshots.model';
import { ParameterDependency } from './parameter-dependency.model';
import { ReportParameter } from './report-parameter.model';
import { ReportDefinition } from './report-definition.model';
import { StudentDigitalContent } from '../../../student360/student-digital-content/models/student-digital-content.model';
// import { StudentDocuments} from '../../../shared-components/student/student-documents.model';
import { Portfolio } from '../../../student360/portfolio/portfolio.model';
import { DocumentArchivePermissions } from './document-archive-permissions.model';
import { ReportBatch } from './report-batch.model';

export class Report {
  Id: number;
  Name: string;
  Procedure: string;
  Type: string;
  URL: string;
  AutoRun: string;
  AutoRunReport: boolean;
  AutoRunSchedule_ID: number;
  AutoRunFrequency: number;
  AutoRunDate: Date;
  AutoRunTime: string;
  AutoRunDay: string;
  Snapshots: AutoRunSnapshot[];
  ReportFolder: string;
  ReportFormat: string;
  Parameters: ReportParameter[];
  Dependencies: ParameterDependency[];
  ReportDefinitions: ReportDefinition[];
  IsSysGen: number;
  ShowReportOptions: boolean;
  SendToEmail: boolean;
  IsDistributeByEmail: boolean;
  EmailFrom: string;
  EmailsToSendReport: string;
  EmailSubject: string;
  EmailBody: string;
  IsDistrictReportDefinitions: boolean;
  GetSelectedReportDefintionsOnly: boolean;
  AllowAutoRun: boolean;
  AllowTCMArchiving: boolean;
  AllowStudentDigitalContent: boolean;
  AllowStudentPortfolio: boolean;
  // properties from services to attempt to pre-populate certain parameters in the DTO
  SelectedSubjectId: number;
  SelectedSubjectCode: string;
  SelectedSectionId: number;
  SelectedSectionName: string;
  SelectedStudentId: number;

  // UseReportDefinitions: boolean;
  // ParameterRows: ParameterRow[];
  // WeeklyTime: string;
  // DailyTime

  // archive properties:
  IsArchiveReport: boolean;

  StudentDigitalContent: StudentDigitalContent;
  HasUniqueStudentParameter: boolean;
  HasDistributeByEmailParameter: boolean;

  StudentPortfolio: Portfolio; // StudentDocuments;

  ArchiveToTCM: boolean; // when they click to save to TCM
  TCM_DocumentType: string;

  ShowArchiveToPdfButton: boolean;
  DocumentArchivePermissions: DocumentArchivePermissions[];

  // parameter groups

  UseParameterGroups: boolean; // so I can turn off this functionality until I get all of the parts into place -- ONE-2400

  // parameter formatting

  UseParameterFormatting: boolean; // so I can turn off this functionality until I get all of the parts into place -- ONE-2400

  ReportBatch: ReportBatch;
  ArchiveToStudentPortfolio: boolean;
  ArchiveToStudentDigitalContent: boolean;

  QueryString: string;
  Login_ID: number;

  UtilizeTranscriptTracking: boolean;

}





